export const skData = [{
  "left": 0,
  "top": 0,
  "width": 375,
  "height": 925,
  "cornerRadius": 0,
  "skeletonColor": -657931
}, {
  "left": 0,
  "top": 0,
  "width": 375,
  "height": 925,
  "cornerRadius": 17,
  "skeletonColor": -1184275
}, {
  "left": 9,
  "top": 12,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 47,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 67,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 87,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 107,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 127,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 21,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 21,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 193,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 228,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 248,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 268,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 288,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 308,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 202,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 202,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 374,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 409,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 429,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 449,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 469,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 489,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 383,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 383,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 555,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 590,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 610,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 630,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 650,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 670,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 564,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 564,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 736,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 771,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 791,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 811,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 831,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 851,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 745,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 745,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 0,
  "top": 0,
  "width": 375,
  "height": 925,
  "cornerRadius": 17,
  "skeletonColor": -1184275
}, {
  "left": 9,
  "top": 12,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 47,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 67,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 87,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 107,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 127,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 21,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 21,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 193,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 228,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 248,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 268,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 288,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 308,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 202,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 202,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 374,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 409,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 429,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 449,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 469,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 489,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 383,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 383,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 555,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 590,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 610,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 630,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 650,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 670,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 564,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 564,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 9,
  "top": 736,
  "width": 357,
  "height": 173,
  "cornerRadius": 12,
  "skeletonColor": -1
}, {
  "left": 124,
  "top": 771,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 791,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 811,
  "width": 187,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 831,
  "width": 109,
  "height": 14,
  "cornerRadius": 2,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 851,
  "width": 224,
  "height": 44,
  "cornerRadius": 40,
  "skeletonColor": -657931
}, {
  "left": 18,
  "top": 745,
  "width": 97,
  "height": 155,
  "cornerRadius": 6,
  "skeletonColor": -657931
}, {
  "left": 124,
  "top": 745,
  "width": 226,
  "height": 20,
  "cornerRadius": 2,
  "skeletonColor": -657931
}];